import React, {useState}from 'react'

import {Typography, Card, CardActions, CardContent,CardMedia ,Button, Box, Modal} from '@mui/material'

import {ThumbUpAltOutlined,  Delete} from '@mui/icons-material'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import moment from 'moment'

import {useDispatch, useSelector} from 'react-redux'

import {setCurrentId} from '../../../features/posts/posts'
import {deletePost, likedPost} from '../../../features/posts/postthunk'


import {Styles} from './Styles'


const Post = ({post, handleOpenFormModal}) => {
const styles = Styles()
const {currentUser} = useSelector((state)=> state.user)
const dispatch = useDispatch()
const [open, setOpen] = useState(false);
const handleClose = () => setOpen(false);
const handleOpen = () => setOpen(true);
const handleLikePost =(e) =>{
dispatch(likedPost(post._id))
}
const editPost=(e)=>{
dispatch(setCurrentId(post._id))
handleOpenFormModal()
 handleClose()
}
const LikeButton = ({post}) => {
    if(post.Likes?.length===0) return  (<Button sx={{fontFamily:'Segoe UI'}} variant='text' onClick={handleLikePost } > <ThumbUpAltOutlined fontSize="small" /></Button>)
    if(post.Likes?.includes(currentUser._id)) return ( <Button sx={{fontFamily:'Segoe UI'}} variant='text' onClick={handleLikePost } > <ThumbUpAltIcon fontSize="small" />you {post.Likes?.length >=2 && `and, ${post.Likes.length-1} others`} liked this post</Button>
)
 return( <Button 
   sx={{fontFamily:'Segoe UI'}}
    variant='text' 
   onClick={handleLikePost } >
      <ThumbUpAltOutlined fontSize="small" />
      {post.Likes?.length > 1 ? `${post.Likes?.length} people` : 'a person'} liked this post
       </Button>)

}
  return (
    <Card  sx={styles.postCard}>
      <CardMedia
        alt="post-image"
        height="140"
      component ='img'
      image={post.selectedFile}
       />
      <div style={styles.creatorContainer}>
         <div>
         <Typography variant="h6" sx={{color:'white'}}>{post.Creator}</Typography>
          <Typography variant="body2" sx={{color:'white'}} >{moment(post.createdAt).fromNow()}</Typography>
       </div>
       <div>
        {(currentUser?.Name===post.Creator) && ( <Button variant='' onClick={editPost} > 
         <MoreVertIcon fontSize="small" sx={{color:'white'}}/>
         </Button>)}
       </div>
      </div>
        <div>
         <Typography variant="body1" sx={styles.tagsContainer}>{post.Tags?.map(tag=>(`  #${tag} `))}</Typography>
       </div>
         <CardContent>
        <Typography  gutterBottom variant="h6" color="text.secondary">
         {post.Title}
        </Typography>
        <Typography   variant="body2" color="text.secondary">
         {post.Message}
        </Typography>
      </CardContent>
      <CardActions sx={styles.postActions}>
      
{(currentUser) && (<LikeButton post={post} /> )}       
       {(currentUser?.Name===post.Creator) && ( <Button sx={{fontFamily:'Segoe UI'}}  variant='text' onClick={()=>{handleOpen()}} >
           <Delete fontSize="small" />DELETE
           </Button>)}
       <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.postActionModal}>
          <Typography id="modal-modal-title" variant="body1" component="h4" >
            Delete or edit post
          </Typography>
        <div style={styles.postActionButtons}>
          <Button variant='contained' color='error'onClick={(e) => {dispatch(deletePost(post._id)); handleClose()}} >DELETE</Button>
          <Button variant='contained' color='primary' onClick={editPost}>EDIT</Button>
        </div>
        </Box>
      </Modal>
       
      </CardActions>
    </Card>
      )
}

export default Post